@use "@design/design-tokens/typography/typography" as *;
@use "@design/design-tokens/border-radius/border-radius" as *;

.root {
  height: 40px;
  @include border-radius-r3;
  border: 1px solid var(--border-soft);
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px;
  gap: 4px;
}

.horizonItem {
  padding: 6px 8px;
  @include typography-v2-body-sm;

  &:hover {
    background-color: var(--surface-hover);
    cursor: pointer;
  }

  &[data-selected="true"] {
    cursor: default;
    @include border-radius-r2;
    background: var(--action-primary-soft-hover);
    color: var(--text-primary);
  }
}

.fullWidth {
  width: 100%;
  height: 36px;
  @include border-radius-r2;
  background-color: var(--background-soft);
  justify-content: space-between;

  .horizonItem {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    text-align: center;
    padding: 4px 0;
    @include typography-v2-ui-xs;
    color: var(--text-default);
    @include border-radius-r1;

    &:hover {
      background-color: var(--surface-hover);
    }

    &[data-selected="true"] {
      background-color: var(--surface-default);
      color: var(--text-default);

      &:hover {
        background-color: var(--surface-default);
      }
    }
  }
}
